module.exports = __webpack_public_path__ + "static/media/grin-tears.fdeb5308.svg";